// extracted by mini-css-extract-plugin
export default {"root":"BlockSocialMediaLink_root__XOhI5","link":"BlockSocialMediaLink_link__5T-e+","media":"BlockSocialMediaLink_media__2l7l8","text":"BlockSocialMediaLink_text__8IMVv"};